// This file was generated automatically as a part of the SourceWhale ES6 refactor 🐳.
import { initializeGeneralUtils } from "../src/general/utils";
import { bindSystemBannerNotifications } from "../../../svelte/src/bindings/system-banner-notifications.js";
import { bindTestPanel } from "../../../svelte/src/bindings/test-panel-prod.js";
import { initializeConfig } from "../src/general/config.js";
import { initializeTheme } from "../src/general/theme.js";
import { initializeTracking } from "../src/general/tracking.js";
import { initializeVisibilities } from "../src/general/visibilities.js";
import { initializeSignin } from "../src/signin/signin.js";

bindTestPanel();
bindSystemBannerNotifications();
initializeTheme();
initializeConfig();
initializeGeneralUtils();
initializeVisibilities();
initializeSignin();
initializeTracking();
